module.exports = __webpack_public_path__ + "static/media/shoe.5103adac.svg";